import { render, staticRenderFns } from "./fault-edit.vue?vue&type=template&id=647d989c&scoped=true&"
import script from "./fault-edit.vue?vue&type=script&lang=js&"
export * from "./fault-edit.vue?vue&type=script&lang=js&"
import style0 from "./fault-edit.vue?vue&type=style&index=0&id=647d989c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d989c",
  null
  
)

export default component.exports